import styled from 'styled-components'
import { BaseInput, BaseTextArea } from 'components/Inputs/Base'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 100px;
`

export const Row = styled(Container)`
  width: 100%;
  padding: 0px;
  gap: 10px;
  margin-bottom: 15px;
  flex-direction: row;
  align-items: flex-start;
`

export const CheckRow = styled(Row)`
  margin-bottom: 10px;
  flex-direction: row;
  align-items: center;

  label, p {
    cursor: pointer;
    margin-bottom: 1px;
  }
`

export const CalendarContainer = styled(Container)`
  padding: 0px;
  margin: 0px 30px 0px 0px;
`

export const FormField = styled(Container)`
  flex: 1;
  justify-content: flex-end;
  padding: 0px;
`

export const ProductGrid = styled.div`
  width: 100%;
  display: grid;
  position: relative;
  gap: 10px;
  align-items: flex-start;
  margin: 6px 0px 3px;
  padding: 5px 0px 0px;
  border-top: 1px solid #F0F0F0;
  grid-template-columns: 260px 140px auto;
  cursor: auto;
`

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const Input = styled(BaseInput)`
  width: 100%;
  margin: 0px;
`

export const TextArea = styled(BaseTextArea)`
  width: 100%;
`

export const Label = styled.label`
  text-align: center;
  color: #000000;
  line-height: 15px;
  margin-bottom: 7px;

  &:hover {
    cursor: pointer;
  }
`

export const InfoText = styled.p`
  color: #000000;
  text-align: center;
  align-self: center;
  margin-bottom: 10px;
`

export const WarningText = styled(InfoText)`
  color: #FF3939;
  margin-bottom: 0px;
`

export const ErrorContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 9px;
  margin: 10px 0px 15px;
  width: 100%;
  border-radius: 15px;
  color: #FFFFFF;
  background-color: #FF3939;
`
